import './author.styles';

import { getTemplateData } from '@/scripts/utils/cms';
import initBlogLayout from '@/layouts/blog/blog-layout';
import initPage from '@/scripts/init/init';
import ImgLazyLoad from '@/scripts/lib/ImgLazyLoad';
import Pagination from '@/components/Pagination/Pagination';

const $page = document.querySelector('.author-js');
const $pagination = $page.querySelector('.pagination-js');

const page = getTemplateData('page');
const maxPage = getTemplateData('maxPage');

initPage();
initBlogLayout();
new ImgLazyLoad(document.querySelectorAll('img.lazy'));

const pagination = new Pagination($pagination, { manualRouting: false });
pagination.cur = page;
pagination.pages = maxPage;
pagination.render();

(function setHumEvents(){
  if (!window.humTracker) return;
  
  humTracker.trackScroll($page, 'author scroll');
  humTracker.trackClick($pagination, 'author pagination click');
  
}());
